import * as SVGInjector from "svg-injector";

/**
 * Replaces img elements with svg
 *
 * @export
 * @class ITSSVGInject
 */
export class SVGInject {

  public static autoInit() {
    const svgInject = new this({
      animate: true,
    });
  }

  private animate: boolean;
  private selector: any;
  private animateRandomDelay: boolean;

  static get DEFAULT_SELECTOR() {
    return "img[data-svg-inject]";
  }

  static get DEFAULT_ANIMATE() {
    return false;
  }

  static get DEFAULT_ANIMATE_RANDOM_DELAY() {
    return false;
  }

  constructor(params: {
    selector?: string,
    animate?: boolean,
    animateRandomDelay?: boolean,
  }) {

    this.selector = params.selector
      || SVGInject.DEFAULT_SELECTOR;

    this.animate = params.animate
      || SVGInject.DEFAULT_ANIMATE;

    this.animateRandomDelay = params.animateRandomDelay
      || SVGInject.DEFAULT_ANIMATE_RANDOM_DELAY;

    this.inject();
  }

  get elementsToInject() {
    return document.querySelectorAll(this.selector);
  }

  get options() {
    return {
      evalScripts: "never", // Just. Don't.
      pngFallback: void 0, // Screw IE6
      each: this.onInjected.bind(this),
    };
  }

  public onInjected(svg: any): void {
    if (this.animate === true) {
      const currentClassName = svg.getAttribute("class");
      const newClassName = `${currentClassName} svg-inject--animate`;
      if (this.animateRandomDelay === true) {
        const randomDelay = Math.floor(Math.random() * (1000 - 0 + 1)) + 0;
        svg.style.animationDelay = `${randomDelay}ms`;
      }
      svg.setAttribute("class", newClassName);
    }
  }

  public onInjectedComplete(/* count */): void {
    return void 0;
  }

  public inject(): void {
    SVGInjector(
      this.elementsToInject,
      this.options,
      this.onInjectedComplete.bind(this),
    );
  }
}



// WEBPACK FOOTER //
// ./components/svg-inject/svg-inject.ts